import { Observable, ReplaySubject } from 'rxjs';
import { ImageContainer } from './image-container';

export abstract class AbstractEditTool {
    container: ImageContainer;

    // Image Width at the time of tool starts
    private _originalImageWidth: number = -1;
    get originalImageWidth() {
        return this._originalImageWidth;
    }
    // Image Width at the time of tool starts
    private _originalImageHeight: number = -1;
    get originalImageHeight() {
        return this._originalImageHeight;
    }

    private static _hasChanges = new ReplaySubject<boolean>(1);
    public static hasChanges: Observable<boolean> = this._hasChanges.asObservable();

    constructor(container) {
        this.container = container;
    }

    /**
    * Load funtion copy the Y to X.
    * Set new X as this tools image
    * Updates the container image with current editors image.
    * Should perform anything else needed for subclass.
    */
    abstract load(options?: any): Promise<void>;

    /**
     * 1. Should transformation applied to X during the lifecyle of the tool, to Y
     * 2. Must update the container image element with new Y
     * Should perform anything else needed for subclass.
     */
    abstract finalize(): Promise<void>;

    abstract updateYImage(): Promise<HTMLImageElement>;

    abstract handleResizeEvent(): void;

    resizeMouseDown(e): void {
        // no-op
    }
    
    mouseMove(e): void {
        // no-op
    }

    public readonly notifyHasChanges = (changed: boolean) => {
        AbstractEditTool._hasChanges.next(changed);
    }

    getContainer(): ImageContainer {
        return this.container;
    }

    updateOriginalImageSize() {
        this._originalImageWidth = this.container.photoModal.originalImageWidth;
        this._originalImageHeight = this.container.photoModal.originalImageHeight;
    }
}
